// DS2609001 发货周期；由 src/api/index.js 自动注册为 this.$q.shippingPeriod。
const base = '/ec-pc-api'

export default {
  versions: { type: 'get', url: `${base}/delivery-cycle/package/timeVersions` },
  filters: { type: 'get', url: `${base}/delivery-cycle/package/filterOptions` },
  packages: { type: 'post', url: `${base}/delivery-cycle/package/page` },
  skus: { type: 'post', url: `${base}/delivery-cycle/sku/page` },
  packageDetail: { type: 'get', url: `${base}/delivery-cycle/package/detail` },
  skuDetail: { type: 'get', url: `${base}/delivery-cycle/sku/detail` },
  productPacks: { type: 'post', url: '/ec-pc-api/pack/listByProductCode' },
  goodsPacks: { type: 'post', url: '/ec-pc-api/pack/listByGoodsCode' },
  classifications: { type: 'post', url: `${base}/delivery-cycle/config/package-class/page` },
  shelfOptions: { type: 'get', url: `${base}/delivery-cycle/config/package-class/shelfClassOptions` },
  productionOptions: { type: 'get', url: `${base}/delivery-cycle/config/package-class/productionClassOptions` },
  saveClassification: { type: 'post', url: `${base}/delivery-cycle/config/package-class/save` },
  updateClassification: { type: 'post', url: `${base}/delivery-cycle/config/package-class/update` },
  rules: { type: 'post', url: `${base}/delivery-cycle/config/rule/page` },
  ruleDetail: { type: 'get', url: `${base}/delivery-cycle/config/rule/detail` },
  ruleDict: { type: 'get', url: `${base}/delivery-cycle/config/rule/dictOptions` },
  saveRule: { type: 'post', url: `${base}/delivery-cycle/config/rule/save` },
  updateRule: { type: 'post', url: `${base}/delivery-cycle/config/rule/update` },
  fixed: { type: 'post', url: `${base}/delivery-cycle/config/sku-fixed-cycle/page` },
  skuInfo: { type: 'get', url: `${base}/delivery-cycle/config/sku-fixed-cycle/skuInfo` },
  saveFixed: { type: 'post', url: `${base}/delivery-cycle/config/sku-fixed-cycle/save` },
  updateFixed: { type: 'post', url: `${base}/delivery-cycle/config/sku-fixed-cycle/update` },
  jd: { type: 'post', url: `${base}/delivery-cycle/import/jd-demand/page` },
  listing: {
    type: 'post',
    url: '/ec-goods-new-api/productList/deliveryCycleMaintainList'
  },
  editListing: { type: 'post', url: '/ec-goods-new-api/productList/deliveryCycleEdit' }
}
